import * as request from "superagent";

export async function loadLicenseV2(user: User, orgID: string) {
  if (
    user !== undefined &&
    orgID !== undefined &&
    user.accessToken !== undefined
  ) {
    const REQUEST =
      process.env.NEXT_PUBLIC_INVOICE_API +
      "license" +
      "?orgID=" +
      orgID +
      "&userID=" +
      user.userID +
      "&accessToken=" +
      user.accessToken;

    try {
      const res = await request.get(REQUEST).send();
      return res.body;
    } catch (err) {
      console.error("Error fetching license:", err);
      return null;
    }
  }
  return null;
}
